import ListCircleCheck from 'assets/icons/list-circle-check.svg';
import CloudUpload from 'assets/icons/cloud-upload.svg';
import CloudCheck from 'assets/icons/cloud-check.svg';
import Analytics from 'assets/icons/analytics.svg';
import Setting from 'assets/icons/setting.svg';
import Support from 'assets/icons/support.svg';
import Audit from 'assets/icons/audit.svg';
import Tool from 'assets/icons/tool.svg';

export const cloudMigrationPropsData = [
  {
    src: Analytics,
    title: 'Анализируем запрос и цели',
    text: 'Проводим первичную консультацию, определяем бизнес‑цели миграции, ограничения, риски и ожидаемый результат',
  },
  {
    src: Audit,
    title: 'Проводим аудит текущей инфраструктуры',
    text: 'Оцениваем архитектуру, нагрузки, зависимости, безопасность и стоимость владения текущей ИТ-среды',
  },
  {
    src: CloudCheck,
    title: 'Подбираем оптимальную модель облака',
    text: 'Подбираем публичную, частную, гибридную или многооблачную (Public, Private, Hybrid, Multi-cloud) модель с учётом надёжности, возможности расширения и экономики',
  },
  {
    src: ListCircleCheck,
    title: 'Разрабатываем стратегию и дорожную карту миграции',
    text: 'Формируем поэтапный план миграции с учётом рисков, сроков, ресурсов и бизнес-приоритетов',
  },
  {
    src: Setting,
    title: 'Готовим инфраструктуру и платформу',
    text: 'Разворачиваем облачную платформу, настраиваем сети, безопасность, процессы разработки (DevOps) и готовим среду к миграции',
  },
  {
    src: CloudUpload,
    title: 'Выполняем миграцию и тестирование',
    text: 'Переносим приложения и данные, проводим нагрузочное и функциональное тестирование без критичных простоев',
  },
  {
    src: Tool,
    title: 'Оптимизируем и масштабируем решения',
    text: 'Повышаем отказоустойчивость, оптимизируем затраты, внедряем контейнеризацию и облачные службы (cloud-сервисы)',
  },
  {
    src: Support,
    title: 'Обеспечиваем поддержку и обучение команды',
    text: 'Обеспечиваем все уровни (с первого по четвёртый, L1–L4) поддержки, устраняем происшествия и обучаем коллектив работе с облаком',
    isLineVisible: false,
  },
].map((cardData, i) => ({ ...cardData, step: i + 1 }));
